import ThemeSelector from './ThemeSelector';

export default ThemeSelector;
